export default __webpack_public_path__ + "static/media/general2024-3.055096d8.gif";